/* eslint-disable max-len */

import React from 'react';
import {
  FaWarehouse,
  FaStoreAlt,
  FaSchool,
  FaStore,
  FaPeopleCarry,
  FaBlind,
  FaWalking,
  FaSyncAlt,
} from 'react-icons/fa';

import './styles.css';

export default function Standard({ offline }) {
  if (offline) {
    window.location.reload();
    return null;
  }

  return (
    <div className="container">
      <section className="banner">
        <h2>Obrigado por nos ajudar a construir este mundo mais local.</h2>

        <div className="image">
          <div className="image-builds">
            <FaSchool className="big-build" size={75} color="#bcafa4" />
            <FaStoreAlt className="small-build" size={48} color="#bcafa4" />
            <FaStore className="small-build" size={48} color="#bcafa4" />
            <FaWarehouse className="big-build" size={75} color="#bcafa4" />
          </div>

          <div className="image-people">
            <FaWalking style={{ paddingBottom: 5 }} size={40} color="#000" />
            <FaPeopleCarry size={51} color="#000" />
            <FaBlind style={{ paddingBottom: 5 }} size={40} color="#000" />
          </div>
        </div>
      </section>

      <section className="error-message">
        <p>Você encontrou um erro, mas já fomos avisados e entraremos em contato via Whatsapp o mais breve possível.</p>

        <button type="button" onClick={() => window.location.reload()}>
          <FaSyncAlt size={22} strokeWidth="3" color="#FFF" />
          <h4>Recarregar</h4>
        </button>
      </section>
    </div>
  );
}
